import { useStore } from 'effector-react'
import { Form } from '~/entities/africa/Organizations/CarRental'
import { formSubmitted, createFx } from './model'

export const AddCarRental = () => {
  const isCreating = useStore(createFx.pending)

  return <Form isSubmitting={isCreating} isCreating onSuccess={formSubmitted} />
}
